"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7356],{

/***/ 27356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Nav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/services/config.tsx
var config = __webpack_require__(35618);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/HoverCard/HoverCard.js + 4 modules
var HoverCard = __webpack_require__(6564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Drawer/Drawer.js + 4 modules
var Drawer = __webpack_require__(92716);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(31003);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(87165);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(91759);
// EXTERNAL MODULE: ./src/components/common/icons.tsx
var icons = __webpack_require__(58163);
// EXTERNAL MODULE: ./src/form/components/common/icons.tsx
var common_icons = __webpack_require__(85119);
// EXTERNAL MODULE: ./src/stores/index.ts + 23 modules
var stores = __webpack_require__(27234);
// EXTERNAL MODULE: ./src/components/common/ConnectWallet.tsx + 1 modules
var ConnectWallet = __webpack_require__(12256);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(94491);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 71 modules
var chunk_LAFZBYO7 = __webpack_require__(17276);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs
var react_toastify_esm = __webpack_require__(55678);
// EXTERNAL MODULE: ./src/services/contract.ts + 10 modules
var contract = __webpack_require__(26720);
// EXTERNAL MODULE: ./src/utils/validate.ts
var validate = __webpack_require__(68974);
;// CONCATENATED MODULE: ./src/hooks/staking/useStakingV2Contract.ts













function useStakeV2Contract() {
    var ref = (0,useAccount/* default */.Z)(), address = ref.address, balance = ref.balance, login = ref.login;
    var switchNetworkAsync = (0,dist/* useSwitchNetwork */.g0)().switchNetworkAsync;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var ref1 = (0,react.useState)(false), claiming = ref1[0], setClaiming = ref1[1];
    var data = (0,dist/* useContractReads */.Dm)({
        watch: false,
        scopeKey: "staking-v2-contract",
        contracts: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* stakingV2ContractInfo */.hm), {
                functionName: "stakingV1Balance",
                args: [
                    address
                ]
            }), 
        ]
    }).data;
    var claim = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tokenIds, targetAddress) {
            var resp, e, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (tokenIds.length === 0) {
                            return [
                                2
                            ];
                        }
                        if (!address) {
                            return [
                                2,
                                login()
                            ];
                        }
                        if (claiming) {
                            return [
                                2
                            ];
                        }
                        setClaiming(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            10,
                            11,
                            12
                        ]);
                        if (!switchNetworkAsync) {
                            return [
                                2
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== contract/* stakingV2ContractInfo.chainId */.hm.chainId)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            switchNetworkAsync(contract/* stakingV2ContractInfo.chainId */.hm.chainId)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* writeContract */.n9)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contract/* stakingV2ContractInfo */.hm), {
                                functionName: "claimStakingV1TokenBatch",
                                args: [
                                    tokenIds.map(function(id) {
                                        return Number(id);
                                    }),
                                    targetAddress
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)({
                                hash: resp.hash,
                                confirmations: 2
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,validate/* isSkipError */.D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        react_toastify_esm/* toast.success */.Am.success("Operation successful！");
                        return [
                            2,
                            true
                        ];
                    case 10:
                        e1 = _state.sent();
                        if ((0,validate/* isUserRejectError */.Qd)(e1)) {
                            return [
                                2,
                                false
                            ];
                        }
                        console.error(e1);
                        react_toastify_esm/* toast.error */.Am.error(e1.message);
                        throw new Error(e1.message);
                    case 11:
                        setClaiming(false);
                        return [
                            7
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(tokenIds, targetAddress) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chain,
        switchNetworkAsync,
        claiming,
        address,
        login
    ]);
    console.log("data", data);
    return {
        claim: claim,
        claiming: claiming
    };
}

// EXTERNAL MODULE: ./src/hooks/useRequest.tsx
var useRequest = __webpack_require__(21706);
;// CONCATENATED MODULE: ./src/form/components/demo/analyze/Stepper.tsx

var Stepper = function(param) {
    var steps = param.steps, _active = param.active, active = _active === void 0 ? 1 : _active, _width = param.width, width = _width === void 0 ? 80 : _width, _maxLineWidth = param.maxLineWidth, maxLineWidth = _maxLineWidth === void 0 ? 80 : _maxLineWidth;
    var currentIndex = Math.min(Math.max(1, active), steps.length);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex w-full items-center justify-center transition-all",
        children: steps.map(function(step, index) {
            var isFirst = index === 0;
            var isActive = index + 1 <= currentIndex;
            return [
                !isFirst && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-3 mt-[14px] h-[2px]  flex-1 self-baseline rounded-[34px] ".concat(isActive ? "bg-primary" : "bg-gray2"),
                    style: {
                        maxWidth: maxLineWidth
                    }
                }, "split-".concat(index)),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex flex-col items-center ".concat(isActive ? "opacity-100" : "opacity-60"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex h-[30px] w-[30px] items-center justify-center rounded-full font-bold ".concat(isActive ? " bg-primary text-white" : "text-gray-500 border-gray-500 border"),
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "-left-[calc(50% - 15px)] absolute whitespace-nowrap   -bottom-7 mt-2  text-center text-sm font-normal ".concat(isActive ? "text-primary" : "text-gray-500", " "),
                            style: {
                                width: width
                            },
                            children: step
                        })
                    ]
                }, "step-".concat(index)), 
            ];
        })
    });
};
/* harmony default export */ var analyze_Stepper = (Stepper);

;// CONCATENATED MODULE: ./src/services/format.ts
var trimAddr = function(addr) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6;
    return (addr === null || addr === void 0 ? void 0 : addr.substring(0, 7)) + "..." + (addr === null || addr === void 0 ? void 0 : addr.slice(-n));
};

// EXTERNAL MODULE: ./node_modules/qrcode.react/lib/esm/index.js
var esm = __webpack_require__(84059);
;// CONCATENATED MODULE: ./src/components/network/staking/V1ToV2.tsx














var V1ToV2 = function(param) {
    var opened = param.opened, close = param.close;
    var ref = useStakeV2Contract(), claim = ref.claim, claiming = ref.claiming;
    var ref1 = (0,react.useState)(1), step = ref1[0], setStep = ref1[1];
    var ref2 = (0,react.useState)(""), clubAddress = ref2[0], setClubAddress = ref2[1];
    var ref3 = (0,useAccount/* default */.Z)(), isLogin = ref3.isLogin, login = ref3.login, address = ref3.address;
    var ref4 = (0,react.useState)(new bignumber/* default */.Z(0)), v1Balance = ref4[0], setV1Balance = ref4[1];
    var ref5 = (0,react.useState)(new bignumber/* default */.Z(0)), bonus = ref5[0], setBonus = ref5[1];
    (0,react.useEffect)(function() {
        if (!opened) {
            setStep(1);
        }
    }, [
        opened
    ]);
    var ref6 = (0,useRequest/* default */.Z)(isLogin ? {
        function: "chat/getUserV1Tokens",
        data: {}
    } : null), tokenList = ref6.data, mutate = ref6.mutate;
    var onClaim = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        claim((tokenList || []).map(function(item) {
                            return String(item.id);
                        }), clubAddress)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        mutate()
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        tokenList,
        clubAddress,
        mutate
    ]);
    (0,react.useEffect)(function() {
        var total = new bignumber/* default */.Z(0);
        (tokenList || []).forEach(function(item) {
            total = total.plus(new bignumber/* default */.Z(item.amount));
        });
        setV1Balance(total);
        setBonus(total.multipliedBy(0.1));
    }, [
        tokenList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            opened: opened,
            onClose: close,
            withCloseButton: false,
            centered: true,
            size: 495,
            radius: 16,
            zIndex: 999,
            classNames: {
                body: "bg-[#F9F9F9]"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pt-5 pb-5 relative px-5 flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineCloseCircle */.SV5, {
                            onClick: close,
                            size: 26,
                            className: "fill-primary action "
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-semibold text-xl",
                        children: "Migrate V1 staking balance to V2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "whitespace-pre-line mt-7 text-[#2d2d2d] text-sm font-semibold text-center",
                        children: "Follow the instructions to migrate your V1 staking balance to new wallet in karat.club App."
                    }),
                    !isLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center mt-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "md",
                            radius: "xl",
                            className: "w-[250px]",
                            loading: claiming,
                            onClick: login,
                            children: "Connect wallet"
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full mt-[30px] pb-[50px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(analyze_Stepper, {
                                    active: step,
                                    width: 120,
                                    maxLineWidth: 120,
                                    steps: [
                                        "V1 Staking total",
                                        "Download Karat.club",
                                        "Confirmation", 
                                    ]
                                })
                            }),
                            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-14",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-sm font-semibold",
                                            children: "Current Wallet"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-[6px] rounded-[90px] px-3 py-2 border border-[#d8d8d8] flex items-center ",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "w-4 h-4",
                                                    src: "/assets/zksync-dark-logo.png"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-primary text-sm ml-6",
                                                    children: trimAddr(address)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mt-[30px] rounded-[4px] p-3 border border-[#d8d8d8] text-sm",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "V1 Staking balance:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                v1Balance.toFixed(3),
                                                                " KAT"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex justify-between items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "10% Loyalty Bonus:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                bonus.toFixed(2),
                                                                " KAT"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-base font-bold flex justify-between items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: "V1 Staking total:"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                v1Balance.plus(bonus).toFixed(3),
                                                                " KAT"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center mt-10",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                className: "w-[200px]",
                                                size: "lg",
                                                radius: "xl",
                                                onClick: function() {
                                                    setStep(step + 1);
                                                },
                                                children: "Next"
                                            })
                                        })
                                    ]
                                })
                            }),
                            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-14",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-xs font-semibold",
                                        children: "Please scan the QR code to add Karat.club to your mobile desktop, open the app, register your account, copy the wallet address from the app, and proceed with the guided steps upon successful registration."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center justify-center mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "p-2 bg-white rounded-[10px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                                                    renderAs: "svg",
                                                    size: 80,
                                                    value: "https://www.karat.club/"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "text-primary text-sm mt-3",
                                                children: "Scan to join"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-center gap-5 mt-10",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/app-1.png",
                                                        className: "w-[121px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-[22px] h-[22px] rounded-full flex items-center justify-center absolute -top-2 -left-2 bg-primary text-white text-sm font-semibold",
                                                        children: "1"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/app-2.png",
                                                        className: "w-[121px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-[22px] h-[22px] rounded-full flex items-center justify-center absolute -top-2 -left-2 bg-primary text-white text-sm font-semibold",
                                                        children: "2"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/app-3.png",
                                                        className: "w-[121px]"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "w-[22px] h-[22px] rounded-full flex items-center justify-center absolute -top-2 -left-2 bg-primary text-white text-sm font-semibold",
                                                        children: "3"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                            label: "Karat.club Wallet",
                                            required: true,
                                            placeholder: "Please enter your wallet address in Karat.club app",
                                            classNames: {
                                                input: "rounded-[90px] mt-1"
                                            },
                                            value: clubAddress,
                                            onChange: function(e) {
                                                setClubAddress(e.currentTarget.value);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mt-10",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "w-[200px]",
                                            size: "lg",
                                            radius: "xl",
                                            onClick: function() {
                                                if (clubAddress && (0,validate/* isValidAddress */.At)(clubAddress)) {
                                                    setStep(step + 1);
                                                }
                                            },
                                            children: "Next"
                                        })
                                    })
                                ]
                            }),
                            step === 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-14",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm font-semibold",
                                        children: "Current Wallet"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-[6px] rounded-[90px] px-3 py-2 border border-[#d8d8d8] flex items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "w-4 h-4",
                                                src: "/assets/zksync-dark-logo.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-primary text-sm ml-6",
                                                children: trimAddr(address)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-4 rounded-[4px] p-3 border border-[#d8d8d8] text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "V1 Staking balance:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            v1Balance.toFixed(3),
                                                            " KAT"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "10% Loyalty Bonus:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            bonus.toFixed(2),
                                                            " KAT"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "text-base font-bold flex justify-between items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "V1 Staking total:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            v1Balance.plus(bonus).toFixed(3),
                                                            " KAT"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mt-6 mb-1",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/export.png",
                                            className: "w-10"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-sm font-semibold",
                                        children: "Karat.club Wallet"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-[6px] rounded-[90px] px-3 py-2 border border-[#d8d8d8] flex items-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "w-4 h-4",
                                                src: "/assets/zksync-dark-logo.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-primary text-sm ml-6",
                                                children: trimAddr(clubAddress)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-8 text-center text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "Please make sure the wallet address is correct. "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: "This is an irreversible step."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mt-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "w-[200px]",
                                            size: "lg",
                                            radius: "xl",
                                            onClick: onClaim,
                                            loading: claiming,
                                            children: "Migrate"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var staking_V1ToV2 = (V1ToV2);

// EXTERNAL MODULE: ./src/config/config.js
var config_config = __webpack_require__(35055);
;// CONCATENATED MODULE: ./src/components/common/Nav.tsx
















var DocUrl = "https://docs.karatdao.com";
var BlogUrl = "https://medium.com/@karatdao";
var Nav = function() {
    var tab = (0,config/* getRoute */.B)("dashboard");
    var ref = (0,react.useState)(false), drawerOpened = ref[0], setDrawerOpened = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), networkOpened = ref1[0], ref2 = ref1[1], toggleNetwork = ref2.toggle, closeNetwork = ref2.close;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), productOpened = ref3[0], ref4 = ref3[1], toggleProduct = ref4.toggle, closeProduct = ref4.close;
    var hideMenu = (0,react.useCallback)(function() {
        setDrawerOpened(false);
    }, []);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), migrateOpened = ref5[0], ref6 = ref5[1], openMigrate = ref6.toggle, closeMigrate = ref6.close;
    var announcement = "Migrate your staking v1 token to karat.club";
    var hideAnnouncement = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.app.hideAnnouncement;
    });
    var showAnnouncement = announcement && !hideAnnouncement;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            config_config/* isMaintenance */.b6 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "z-40 h-[30px] sticky top-0 left-0 bg-[#5C74DD] text-white flex items-center justify-center text-xs",
                children: "Server is under maintenance"
            }),
            !config_config/* isMaintenance */.b6 && showAnnouncement && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-40 h-[30px] sticky top-0 left-0 bg-[#5C74DD] text-white flex items-center justify-center text-xs",
                children: [
                    announcement,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "ml-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                onClick: openMigrate,
                                className: "underline action font-semibold",
                                children: "here"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {
                        onClick: function() {
                            stores/* default.dispatch */.ZP.dispatch(stores/* actions.app.hideAnnouncement */.Nw.app.hideAnnouncement());
                        },
                        className: "fill-white w-4 h-4 action absolute right-16"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "z-40 h-[56px] sticky ".concat(showAnnouncement ? "top-[30px]" : "top-0", "  left-0 backdrop-blur bg-white text-base"),
                style: {
                    filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "layout-content flex h-[60px] items-center justify-between sm:justify-start px-5 md:px-14 relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/airdrop_assets/karatdao4x.png",
                                        width: 150,
                                        height: 40,
                                        className: "-translate-y-1 action"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-[10] sm:max-w-[150px] flex flex-1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                                            width: 321,
                                            shadow: "md",
                                            offset: 2,
                                            classNames: {
                                                dropdown: "bg-dark1 border-none shadow-navCard p-0 py-3"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hidden mx-5 font-semibold text-primary sm:flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "action flex items-center px-4 py-4 hover:text-primary text-primary",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Network"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "w-[7px] h-[5px] ml-1",
                                                                    src: "/assets/nav-arrow.png"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/mining",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "KAT"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Multiple ways to earn KAT"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/mission",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "The mission"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Join the journey to own your data"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/claimer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "Karat ID"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Verify web2 data and earn"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/leaderboard",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "Staking"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Stake and participate in KAT mining"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard */.z, {
                                            width: 321,
                                            shadow: "md",
                                            offset: 2,
                                            classNames: {
                                                dropdown: "bg-dark1 border-none shadow-navCard p-0 py-3"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HoverCard/* HoverCard.Target */.z.Target, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "hidden mx-5 font-semibold text-primary sm:flex",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "action flex items-center px-4 py-4 hover:text-primary text-primary",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Products"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    className: "w-[7px] h-[5px] ml-1",
                                                                    src: "/assets/nav-arrow.png"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HoverCard/* HoverCard.Dropdown */.z.Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/#form",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "Form"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Web3 Form to collect wallet addresses"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/#analytics",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "Analytics"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Analyze wallets in batch and get insights"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/#airdrops",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "py-4 cursor-pointer px-7 group",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "font-semibold text-white text-body group-hover:text-tertiary",
                                                                        children: "Airdrops"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-[#8F8F8F] text-xs mt-1",
                                                                        children: "Create claimable token and NFT airdrops"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/airdrops",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "hidden mx-5 font-semibold text-primary sm:flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "action flex items-center px-4 py-4 hover:text-primary text-primary",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Campaigns"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: DocUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "hidden mx-5 font-semibold text-primary sm:flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "action flex items-center px-4 py-4 hover:text-primary text-primary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Doc"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: BlogUrl,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "hidden mx-5 font-semibold text-primary sm:flex",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "action flex items-center px-4 py-4 hover:text-primary text-primary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Blog"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWallet/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: tab.route,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            "data-track": "nav_enter_app",
                                            className: "ml-6 text-sm",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "hidden font-semibold action text-primary sm:block",
                                                children: "Enter App"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "block action sm:hidden",
                                            onClick: function() {
                                                setDrawerOpened(true);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/assets/burger.png",
                                                width: 18,
                                                height: 15
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* Drawer */.d, {
                        opened: drawerOpened,
                        onClose: hideMenu,
                        padding: "xl",
                        size: "100%",
                        position: "right",
                        trapFocus: false,
                        withCloseButton: false,
                        classNames: {
                            body: "h-full"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                className: "absolute hover: top-10 right-7 text-primary",
                                onClick: hideMenu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                                    className: "w-6 h-6"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-between mt-4 h-[90%]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center justify-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UnstyledButton/* UnstyledButton */.k, {
                                                onClick: function() {
                                                    toggleNetwork();
                                                    closeProduct();
                                                },
                                                className: "flex items-center flex-initial mt-10 font-bold justify-items-center text-primary action",
                                                children: [
                                                    "Network",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MenuArrow */.Jq, {
                                                        className: "ml-1 mt-1 transition-all ".concat(networkOpened ? "" : "rotate-180")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                                                in: networkOpened,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-4 bg-dark1 w-[269px] rounded flex flex-col items-center p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/mining",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "KAT"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Multiple ways to earn KAT"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/mission",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action mt-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "The mission"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Join the journey to own your data"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/claimer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action mt-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "Karat ID"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Verify web2 data and earn"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/network/leaderboard",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action mt-4",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "Staking"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Stake and participate in KAT mining"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                onClick: function() {
                                                    toggleProduct();
                                                    closeNetwork();
                                                },
                                                className: "flex items-center flex-initial mt-10 font-bold justify-items-center text-primary action",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        "Products",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MenuArrow */.Jq, {
                                                            className: "ml-1 mt-1 transition-all ".concat(productOpened ? "" : "rotate-180")
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
                                                in: productOpened,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-4 bg-dark1 w-[269px] rounded flex flex-col items-center p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/#form",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action",
                                                                onClick: hideMenu,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "Form"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Web3 form to collect wallet addresses"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/#analytics",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action mt-4",
                                                                onClick: hideMenu,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "Analytics"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Analyze wallets in batch and get insights"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/#airdrops",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "text-center action mt-4",
                                                                onClick: hideMenu,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-white font-semibold text-sm",
                                                                        children: "Airdrops"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "text-xs text-[#8f8f8f] mt-1",
                                                                        children: "Create claimable tokens and NFT airdrops"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                onClick: hideMenu,
                                                className: "flex items-center flex-initial mt-10 font-bold justify-items-center text-primary action",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/airdrops",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: "Campaigns"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                onClick: hideMenu,
                                                className: "flex items-center flex-initial mt-10 font-bold justify-items-center text-primary action",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: DocUrl,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "Doc"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnstyledButton/* UnstyledButton */.k, {
                                                onClick: hideMenu,
                                                className: "flex items-center flex-initial mt-10 font-bold justify-items-center text-primary action",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: BlogUrl,
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "Blog"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center justify-center font-semibold gap-8",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://twitter.com/KaratDAO",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_icons/* TwitterIcon */.Zm, {
                                                    className: "fill-primary h-[18px] w-[22px] action"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://discord.gg/fcvFtkfrRA",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_icons/* DiscordIcon */.D7, {
                                                    className: "fill-primary h-4 w-6 action"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://medium.com/@karatdao",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_icons/* MediumIcon */.OW, {
                                                    className: "fill-primary h-5 w-5 action"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(staking_V1ToV2, {
                opened: migrateOpened,
                close: closeMigrate
            })
        ]
    });
};
/* harmony default export */ var common_Nav = (Nav);


/***/ }),

/***/ 21706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ disableRevalidate; },
/* harmony export */   "Z": function() { return /* binding */ useRequest; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59734);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6293);


var disableRevalidate = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    refreshInterval: 0
};
function useRequest(options, swrOptions) {
    // @ts-ignore
    return (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(options || null, function(options) {
        return _utils_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].rpc */ .Z.rpc(options.function, options.data, // @ts-ignore
        options.header);
    }, swrOptions);
}


/***/ }),

/***/ 68974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ isValidAddress; },
/* harmony export */   "D0": function() { return /* binding */ isSkipError; },
/* harmony export */   "Qd": function() { return /* binding */ isUserRejectError; }
/* harmony export */ });
/* unused harmony exports validateEmail, validateTwitterLink, validateDiscordServerLink, validateDiscordChannelLink, validateTelegramGroupLink */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7258);



var validateEmail = function(email) {
    if (!email) {
        return false;
    }
    return Yup.string().email().isValidSync(email);
};
var RTwitterLink = /^https:\/\/twitter.com\/[^/]+\/status\/\d+/;
var validateTwitterLink = function(url) {
    if (!url) {
        return false;
    }
    return RTwitterLink.test(url);
};
var validateDiscordServerLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("https://discord.gg/") === 0;
};
var validateDiscordChannelLink = function(url) {
    if (!url) {
        return false;
    }
    return url.indexOf("https://discord.com/channels") === 0;
};
var RTelegramGroupLink = /^https:\/\/t.me\/./;
var validateTelegramGroupLink = function(url) {
    if (!url) {
        return false;
    }
    return RTelegramGroupLink.test(url);
};
var REGEX_ADDRESS = /^0x[A-F0-9]{40}$/i;
var isValidAddress = function(address) {
    return REGEX_ADDRESS.test(address);
};
var isUserRejectError = function(error) {
    if (error.message.includes("User rejected the request.")) {
        return true;
    }
    return false;
};
var isSkipError = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(error) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!error.message.includes("Cannot mix BigInt and other types")) return [
                        3,
                        2
                    ];
                    console.log("skip error");
                    console.error(error);
                    return [
                        4,
                        new Promise(function(resolve) {
                            setTimeout(resolve, 10000);
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 2:
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return function isSkipError(error) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);